/**
 * Fichiers logos catalogue (déployés par scripts/sync-module-logos.mjs
 * vers products/itaas-suite/apps/web/public/assets/logos/modules/).
 * Aligné sur logo-registry.csv → pep_catalog_file.
 */
export const MODULE_LAUNCHER_LOGO_FILES: Record<string, string> = {
  suite: "suite.png",
  rh: "rh.png",
  security: "security.png",
  erp: "erp.png",
  procurement: "erp.png",
  edu: "edu.png",
  crm: "crm.png",
  billing: "billing.png",
  finance: "finance.png",
  inventory: "inventory.png",
  legal: "legal.png",
  mineportal: "mineportal.png",
  subportal: "subportal.png",
  hospitol: "hospitol.png",
  comex: "comex.png",
  iam: "iam.png",
  product: "suite.png",
  autoid: "suite.png",
  notifications: "suite.png",
};

export const MODULE_LAUNCHER_LOGO_BASE = "/assets/logos/modules";

export function getModuleLauncherLogoUrl(moduleId: string): string {
  const file = MODULE_LAUNCHER_LOGO_FILES[moduleId] ?? "suite.png";
  return `${MODULE_LAUNCHER_LOGO_BASE}/${file}`;
}
